import { useState } from "react";
import ProfileItem from "../../kits/profileItem/ProfileItem.jsx";
import WalletDrawer from "./WalletDrawer";
// import LogOutaAccount from "./logut/LogOutAccount";
import { NavLink } from "react-router-dom";

import {
  SabadiTextIcon,
  SabadiIcon,
  UserIcon,
  LocationIcon,
  HeadphoneIcon,
  LogoutIcon,
  ArrowLeftIcon
} from "../../kits/Icons/Icons.tsx";
import CustomButton from "../../kits/custom-button/CustomButton.tsx";

import "../../../pages/profileList/profileList.scss";
export default function ManagerProfile() {
  const [walletDrawerShow, setWalletDrawerShow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [profileItem, setProfileItem] = useState([
    {
      // title: auth.userInfo.firstname + " " + auth.userInfo.lastname,
      title: "نام فروشگاه",
      description: "مشاهده و ویرایش اطلاعات کاربری",
      mainIcon: <UserIcon />,
      type: "logged",
      link: "/vendor-panel/shop-info"
    },
    {
      title: "اطلاعات مدیریت",
      description: "مشاهده و ویرایش اطلاعات مدیریت فروشگاه",
      mainIcon: <LocationIcon />,
      type: "logged",
      link: "/vendor-panel/manager-info"
    },
    {
      title: "شیفت های کاری",
      description: "مشاهده و ویرایش شیفت های کاری",
      mainIcon: <LocationIcon />,
      type: "logged",
      link: "/profile-information"
    },
    {
      title: "اطلاعات مالی",
      description: "مشاهده و ویرایش اطلاعات مالی و بانکی",
      mainIcon: <LocationIcon />,
      type: "logged",
      link: "/info-financial"
    },
    {
      title: "کیف پول و پرداختی ها",
      description: "مشاهده موجودی و گزارش واریز و برداشت",
      mainIcon: <UserIcon />,
      type: "logged",
      modal: "true",
      page: "wallet"
      // link: "/profile-information"
    },
    {
      title: "تماس با پشتیبانی",
      description: "تماس با پشتیبانی سبدی",
      mainIcon: <HeadphoneIcon />,
      type: "logged"
    },
    {
      title: "درباره سبدی",
      description: "",
      mainIcon: <SabadiIcon />,
      type: "logged",
      link: "/profile-information"
    },
    {
      title: " خروج از حساب کاربری",
      description: "",
      mainIcon: <LogoutIcon />,
      type: "logged",
      modal: "true"
    }
  ]);

  return (
    <div className="userProfile-style">
      <div className="mr-x-20 mr-t-20 mr-b-16">
        <SabadiTextIcon width={66} height={32} />
      </div>
      <hr className="top-line" />
      {/* {profileItem.reduce((total, value) => {
        if (
          //   !auth.isLogin &&
          value.type == "logged"
        ) {
          return total;
        }

        let component = (
          <ProfileItem
            title={value.title}
            description={value.description}
            mainIcon={value.mainIcon}
            moreIcon={<ArrowLeftIcon />}
          />
        );
        total.push(
          <>
            {total.length != 0 && <hr className="line mr-l-20 mr-r-40" />}
            <div className=" mr-y-16 mr-x-20 items">
              {value.modal == "true" ? (
                <CustomButton
                  className="w-100"
                  buttonStyle="text"
                  style={{ padding: 0 }}
                  onClick={() => {
                    setIsOpen(true);
                  }}
                >
                  {component}
                </CustomButton>
              ) : (
                //   ) : value.isSupport ? (
                //     supportCalls(value)
                <NavLink to={value.link} className="profile-link">
                  {component}
                </NavLink>
              )}
            </div>
          </>
        );
        return total;
      }, [])} */}
      <div className=" mr-y-16 mr-x-20 items">
        {profileItem.map((value, index) => {
          return (
            <div>
              {value.modal == "true" && value.page == "wallet" ? (
                <>
                  <CustomButton
                    className="w-100"
                    buttonStyle="text"
                    style={{ padding: 0 }}
                    onClick={() => {
                      setWalletDrawerShow(true);
                    }}
                  >
                    <ProfileItem
                      title={value.title}
                      description={value.description}
                      mainIcon={value.mainIcon}
                      moreIcon={<ArrowLeftIcon />}
                    />
                  </CustomButton>
                  <hr className="line mr-l-20 mr-r-40" />
                </>
              ) : (
                <>
                  <NavLink to={value.link} className="profile-link">
                    <ProfileItem
                      title={value.title}
                      description={value.description}
                      mainIcon={value.mainIcon}
                      moreIcon={<ArrowLeftIcon />}
                    />
                  </NavLink>
                  {index != profileItem.length - 1 && (
                    <hr className="line mr-l-20 mr-r-40" />
                  )}
                </>
              )}
            </div>
          );
        })}
      </div>
      <WalletDrawer isOpen={walletDrawerShow} setIsOpen={setWalletDrawerShow} />
      {/* <LogOutaAccount isOpen={isOpen} setIsOpen={setIsOpen}></LogOutaAccount> */}
    </div>
  );
}
